import React from 'react';

import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// Mesmo visual das abas da tela Documentos: a aba selecionada é branca e se funde com o
// conteúdo logo abaixo; as demais ficam cinza, apagadas; o número vira uma bolinha no canto.
const useStyles = makeStyles({
  faixa: {
    padding: '12px 16px 0',
    borderBottom: '1px solid #e2e8f0',
  },
  abas: {
    // sem corte, para a bolinha do contador passar da borda da aba (desktop).
    overflow: 'visible',
    minHeight: 42,
  },
  scroller: { overflow: 'visible !important' },
  aba: {
    overflow: 'visible',
    minHeight: 42,
    minWidth: 130,
    margin: '0 4px 0 0',
    textTransform: 'none',
    fontWeight: 600,
    opacity: 1,
    borderRadius: '10px 10px 0 0',
    border: '1px solid #e2e8f0',
    borderBottom: 'none',
    backgroundColor: '#f1f5f9',
    color: '#64748b',
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      gap: 6,
      opacity: 0.6,
      transition: 'opacity 0.15s',
    },
    '&:hover': { backgroundColor: '#f8fafc' },
    '&:hover .MuiTab-wrapper': { opacity: 1 },
    '&.Mui-selected': {
      backgroundColor: '#fff',
      color: '#0f172a',
      // desce 1px sobre a linha da base da faixa: some a divisória sob a aba.
      marginBottom: -1,
      paddingBottom: 1,
      zIndex: 1,
    },
    '&.Mui-selected .MuiTab-wrapper': { opacity: 1 },
  },
  bolinha: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(35%, -40%)',
    minWidth: 20,
    height: 20,
    padding: '0 5px',
    boxSizing: 'border-box',
    borderRadius: 10,
    border: '2px solid #fff',
    backgroundColor: 'var(--cor-aba)',
    color: '#fff',
    fontSize: '0.6875rem',
    fontWeight: 700,
    lineHeight: '16px',
    textAlign: 'center',
    zIndex: 1,
  },
});

/**
 * Abas no estilo de aba de navegador. Controlado: quem usa guarda a aba selecionada.
 *
 * abas: [{ id, name, cor, icon?, contador? }] (`cor` colore o ícone e a bolinha do contador)
 * valor: id da aba selecionada; onChange(id).
 */
const AbasNavegador = ({ abas, valor, onChange }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  return (
    <Box className={classes.faixa}>
      <Tabs
        value={valor}
        onChange={(event, id) => onChange(id)}
        className={classes.abas}
        classes={isMobile ? undefined : { scroller: classes.scroller }}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons={isMobile ? 'auto' : 'off'}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {abas.map((aba) => (
          <Tab
            key={aba.id}
            value={aba.id}
            className={classes.aba}
            label={
              <>
                {aba.icon && (
                  <span style={{ display: 'inline-flex', color: aba.cor }}>
                    {aba.icon}
                  </span>
                )}
                {aba.name}
                {aba.contador != null && (
                  <span
                    className={classes.bolinha}
                    style={{ '--cor-aba': aba.cor }}
                  >
                    {aba.contador > 9999 ? '9999+' : aba.contador}
                  </span>
                )}
              </>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default AbasNavegador;
